"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.polyfillApp = exports.parseCompatibleWallets = exports.calculateDependencies = exports.mapApplicationV2ToApp = exports.getCurrencyIdFromAppName = exports.polyfillApplication = exports.getDependents = exports.getDependencies = exports.declareDep = exports.whitelistDependencies = void 0;
// polyfill the unfinished support of apps logic
const uniq_1 = __importDefault(require("lodash/uniq"));
const semver_1 = __importDefault(require("semver"));
const cryptoassets_1 = require("@ledgerhq/cryptoassets");
const types_live_1 = require("@ledgerhq/types-live");
const directDep = {};
const reverseDep = {};
// whitelist dependencies
exports.whitelistDependencies = [
    "Decred",
    "Decred Test",
    "Bitcoin",
    "Bitcoin Test",
    "Zcash",
    "Avalanche",
    "Avalanche Test",
];
function declareDep(name, dep) {
    if (exports.whitelistDependencies.includes(name)) {
        return;
    }
    directDep[name] = (directDep[name] || []).concat(dep);
    reverseDep[dep] = (reverseDep[dep] || []).concat(name);
}
exports.declareDep = declareDep;
// extra dependencies
[
    ["LBRY", "Bitcoin"],
    ["Ravencoin", "Bitcoin"],
    ["Resistance", "Bitcoin"],
    ["ZenCash", "Bitcoin"],
    ["[ L ] Market", "Ethereum"],
    ["1inch", "Ethereum"],
    ["Aave", "Ethereum"],
    ["Alkemi", "Ethereum"],
    ["Angle", "Ethereum"],
    ["APWine", "Ethereum"],
    ["ArtBlocks", "Ethereum"],
    ["ARTIS sigma1", "Ethereum"],
    ["cBridge", "Ethereum"],
    ["Cometh", "Ethereum"],
    ["Compound", "Ethereum"],
    ["DODO", "Ethereum"],
    ["EnergyWebChain", "Ethereum"],
    ["Euler", "Ethereum"],
    ["Harvest", "Ethereum"],
    ["Kiln", "Ethereum"],
    ["kUSD", "Ethereum"],
    ["Lido", "Ethereum"],
    ["Morpho", "Ethereum"],
    ["Nested", "Ethereum"],
    ["OlympusDAO", "Ethereum"],
    ["Opensea", "Ethereum"],
    ["Paraswap", "Ethereum"],
    ["POAP", "Ethereum"],
    ["Rarible", "Ethereum"],
    ["Ricochet", "Ethereum"],
    ["RocketPool", "Ethereum"],
    ["RSK Test", "Ethereum"],
    ["RSK", "Ethereum"],
    ["Spool", "Ethereum"],
    ["Staderlabs", "Ethereum"],
    ["StakeDAO", "Ethereum"],
    ["ThunderCore", "Ethereum"],
    ["Volta", "Ethereum"],
    ["Yearn", "Ethereum"],
].forEach(([name, dep]) => declareDep(name, dep));
// Nb Starting on version 2.1.0 Bitcoin family apps no longer depend on
// Bitcoin as a library. We will soon have the dependencies resolved from
// back-end but until then we need to manually remove them.
const versionBasedWhitelistDependencies = {
    Bitcoin: "2.1.0",
};
const getDependencies = (appName, appVersion) => {
    const maybeDirectDep = directDep[appName] || [];
    if (!appVersion || !maybeDirectDep.length) {
        return maybeDirectDep;
    }
    // If we don't have any direct dependencies, or the caller didn't
    // provide `appVersion` to compare against, we can skip the filter
    return maybeDirectDep.filter((dep) => {
        var _a;
        const maybeDep = versionBasedWhitelistDependencies[dep];
        return !maybeDep || semver_1.default.lt((_a = semver_1.default.coerce(appVersion)) !== null && _a !== void 0 ? _a : "", maybeDep);
    });
};
exports.getDependencies = getDependencies;
const getDependents = (appName) => reverseDep[appName] || [];
exports.getDependents = getDependents;
const polyfillApplication = (app) => {
    const crypto = (0, cryptoassets_1.listCryptoCurrencies)(true, true).find(crypto => app.name.toLowerCase() === crypto.managerAppName.toLowerCase() &&
        (crypto.managerAppName !== "Ethereum" ||
            // if it's ethereum, we have a specific case that we must only allow the Ethereum app
            app.name === "Ethereum"));
    if (crypto && !app.currencyId) {
        return Object.assign(Object.assign({}, app), { currencyId: crypto.id });
    }
    return app;
};
exports.polyfillApplication = polyfillApplication;
const getCurrencyIdFromAppName = (name) => {
    const crypto = 
    // try to find the "official" currency when possible (2 currencies can have the same manager app and ticker)
    (0, cryptoassets_1.findCryptoCurrency)(c => c.name === name) ||
        // Else take the first one with that manager app
        (0, cryptoassets_1.findCryptoCurrency)(c => c.managerAppName === name);
    return crypto === null || crypto === void 0 ? void 0 : crypto.id;
};
exports.getCurrencyIdFromAppName = getCurrencyIdFromAppName;
/**
 * Due to the schema returned by the Manager API we need this key remapping and
 * slight polyfill because we are not the only consumers of the API and they
 * can't give us exactly what we need. It's a pity but it's our pity.
 * @param param ApplicationV2
 * @returns App
 */
const mapApplicationV2ToApp = (_a) => {
    var { versionId: id, versionName: name, versionDisplayName: displayName, firmwareKey: firmware_key, // No point in refactoring since api wont change.
    deleteKey: delete_key, applicationType: type, compatibleWallets, parentName } = _a, rest = __rest(_a, ["versionId", "versionName", "versionDisplayName", "firmwareKey", "deleteKey", "applicationType", "compatibleWallets", "parentName"]);
    return (Object.assign(Object.assign({ id,
        name,
        displayName,
        firmware_key,
        delete_key, dependencies: parentName ? [parentName] : [], indexOfMarketCap: -1, type: name === "Exchange" ? types_live_1.AppType.swap : type }, rest), { currencyId: (0, exports.getCurrencyIdFromAppName)(name), compatibleWallets: (0, exports.parseCompatibleWallets)(compatibleWallets, name) }));
};
exports.mapApplicationV2ToApp = mapApplicationV2ToApp;
const calculateDependencies = () => {
    (0, cryptoassets_1.listCryptoCurrencies)(true, true).forEach((currency) => {
        if (!currency.managerAppName)
            return; // no app for this currency
        const family = (0, cryptoassets_1.findCryptoCurrencyById)(currency.family);
        if (!family || !family.managerAppName)
            return; // no dep
        if (family.managerAppName === currency.managerAppName)
            return; // same app
        declareDep(currency.managerAppName, family.managerAppName);
        if (!currency.isTestnetFor) {
            declareDep(currency.managerAppName + " Test", family.managerAppName);
        }
    });
};
exports.calculateDependencies = calculateDependencies;
const parseCompatibleWallets = (compatibleWalletsJSON, appName) => {
    const compatibleWallets = [];
    if (compatibleWalletsJSON) {
        try {
            const parsed = JSON.parse(compatibleWalletsJSON);
            if (parsed && Array.isArray(parsed)) {
                parsed.forEach(({ name, url }) => {
                    compatibleWallets.push({
                        name,
                        url,
                    });
                });
            }
            return parsed;
        }
        catch (e) {
            console.error("invalid compatibleWalletsJSON for " + appName, e);
        }
    }
    return compatibleWallets;
};
exports.parseCompatibleWallets = parseCompatibleWallets;
const polyfillApp = (app) => {
    const dependencies = exports.whitelistDependencies.includes(app.name) ? [] : app.dependencies;
    return Object.assign(Object.assign({}, app), { dependencies: (0, uniq_1.default)(dependencies.concat((0, exports.getDependencies)(app.name, app.version))) });
};
exports.polyfillApp = polyfillApp;
//# sourceMappingURL=polyfill.js.map